module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-ira002.3396558f.png";